import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserProfileToolbarComponent } from './user-profile-toolbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { IonicModule } from '@ionic/angular';
import { ResizeColumnModule } from 'src/app/core/directive/resize-column.module';
import { FilterSelectionModule } from '../filter/filter-selection/filter-selection.module';
import { ToggleMenuButtonModule } from '../toggle-menu-button/toggle-menu-button.module';
import { RouterModule } from '@angular/router';
import { SecurePipeModule } from 'src/app/core/pipes/secure-file-pipe.module';

@NgModule({
  declarations: [UserProfileToolbarComponent],
  imports: [
    CommonModule,
    IonicModule.forRoot({}),
    MatTableModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    FormsModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    ResizeColumnModule,
    FilterSelectionModule,
    ToggleMenuButtonModule,
    RouterModule,
    SecurePipeModule,
  ],
  exports: [UserProfileToolbarComponent],
})
export class UserProfileToolbarModule {}
